
import './not-control-logo/control-logo';
import './managing-org-device-report/managing-org-device-report.component'

function ReportsCtrl(
  $scope,
  $state,
  $stateParams,
  sweet,
  DateManipulationService,
  ReportingService,
  SessionsService
) {
  "ngInject";

  let vm = this;

  vm.managingOrgId = undefined;
  vm.isManagingOrgAdmin = false;

  vm.initialize = () => {
    vm.managingOrgId = SessionsService.getCurrentDistributorKey();
    vm.isManagingOrgAdmin = SessionsService.isManagingOrgAdmin(vm.managingOrgId);
  };
  vm.initialize();
}

export {ReportsCtrl}
